import React, { PropTypes } from 'react'
import styled from 'styled-components'
import { Fonts, Metrics, Colors } from '../../Themes'

const Tile = styled.div`
  text-align: center;
  p {
    ${props => props.textStyle || Fonts.style.Text};
    padding-top: ${Metrics.margins.base};
    color: ${Colors.black};
    margin: 0px;
    line-height: 15px;
  }
`

const Icon = styled.div`
  max-width: 200px;
  margin-left: calc((100% - 200px)/2)
  text-align: center;
`

const TileWithIcon = props => {
  const { icon, text } = props

  return (
    <Tile {...props}>
      <Icon>{icon}</Icon>
      <p>{text}</p>
    </Tile>
  )
}

TileWithIcon.propTypes = {
  icon: PropTypes.node,
  text: PropTypes.node,
  textStyle: PropTypes.object
}

export default TileWithIcon



// WEBPACK FOOTER //
// ./src/components/TileWithIcon/index.js